import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function QRRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/q/${code}`)
      .then(r => {
        if (cancelled) return;
        const { restaurant_id, table_id } = r.data || {};
        if (restaurant_id && table_id) {
          navigate(`/r/${restaurant_id}/table/${table_id}`, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      })
      .catch(() => {
        if (!cancelled) navigate('/', { replace: true });
      });
    return () => { cancelled = true; };
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="w-8 h-8 border-3 border-orange-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
